/** Shared portal design tokens — aligned with VBS bright logo-aligned storefront. */
export const PORTAL = {
  accent: "#FF5C00",
  accentHover: "#E04F00",
  accentSoft: "rgba(255, 92, 0, 0.12)",
  accentBorder: "rgba(255, 92, 0, 0.28)",
  canvas: "#F7F8FA",
  surface: "#FFFFFF",
  panel: "#F7F8FA",
  ink: "#0F0F12",
  muted: "#55575C",
  subtle: "#6E7278",
  line: "rgba(15, 15, 18, 0.08)",
  lineStrong: "rgba(15, 15, 18, 0.1)",
  danger: "#A51812",
  dangerSoft: "rgba(215, 38, 30, 0.07)",
  success: "#147A5C",
  successSoft: "rgba(20, 122, 92, 0.08)",
  radius: 8,
  radiusSm: 6,
  shadow: "0 2px 0 rgba(15,15,18,0.04), 0 12px 28px rgba(15,15,18,0.06)",
  shadowLift: "0 4px 0 rgba(255,92,0,0.16), 0 16px 36px rgba(15,15,18,0.08)",
  railWidth: 248,
  fontMono: 'ui-monospace, "SF Mono", "Cascadia Code", monospace',
};

export function mergePortalAccent(theme, accent) {
  const a = accent || PORTAL.accent;
  return {
    ...PORTAL,
    accent: a,
    accentSoft: `${a}14`,
    accentBorder: `${a}38`,
  };
}
